import { Pipe, PipeTransform } from '@angular/core';
import { AppConfig } from 'src/app/app-config.loader';

@Pipe({
  name: 'classificai18n'
})
export class ClassificaI18nPipe implements PipeTransform {
  public qualifica: number | null | undefined;
  public classifica: string | null | undefined;

  constructor(private appConfig: AppConfig) { }

  transform(classificaIt: string | null, qualifica: number | null | undefined): string {
    this.qualifica = qualifica;
    this.classifica = classificaIt;

    if (!this.classifica) { return ''; }
    if (!this.qualifica) { return this.classifica; }

    const classifiche = this.appConfig.text.classifiche[this.qualifica];
    if (!classifiche) { return this.classifica; }

    const i18nText: string = classifiche[this.classifica.toLowerCase()];
    return i18nText ? (i18nText.charAt(0).toUpperCase() + i18nText.slice(1)) : this.classifica;
  }
}
